import React, { useState } from "react";
import { Button } from '@headlessui/react';

import btnStyles from "../../../styles/btn.module.scss"
import { Checkbox } from "../../../comps/checkbox";

export default function TermsWindow({ open, onClose }: { open: boolean, onClose: (confirmed: boolean) => void, children: React.ReactNode }) {

  const [checked, setChecked] = useState(false);

  if(!open) return false;

  return (
    <>
      <div className="tw-fixed tw-inset-0 tw-bg-gray-900 tw-opacity-40 tw-z[4]"></div>
      <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-p-1 tw-z-[4]">
        <div className="tw-w-full md:tw-max-w-2xl tw-h-4/5 tw-z-50 tw-bg-white tw-border tw-border-solid tw-border-gray-50 tw-rounded-md tw-shadow-md tw-shadow-gray-500 tw-flex tw-flex-col tw-p-2">
          <div className="tw-grow">
            <iframe style={{border: "solid 1px #e5e2da"}} src="/terms-and-conditions-for-ta-portal.html" className="tw-w-full tw-h-full"></iframe>
          </div>

          <div className="tw-py-2 tw-flex tw-flex-row">
            <div className="tw-grow">
              <Checkbox checked={checked} onChange={() => setChecked(v => !v)}>I acknowledge that I have read, understood, and agree to the terms and conditions.</Checkbox>
            </div>
            <Button className={btnStyles.secondary} onClick={() => onClose(checked)}>Confirm</Button>
          </div>
        </div>
      </div>
    </>
  )
}